// extracted by mini-css-extract-plugin
export default {"points-system-modal-container":"PointsRequestsForm_points-system-modal-container__4U5lM","remaining":"PointsRequestsForm_remaining__UnVj5"};